import useInput from "@Features/input/hooks/useInput";
import useInputError from "@Features/input/hooks/useInputError";
import {useScroll} from "@Scroll/hooks/useScroll";
import ContactFormInputFieldType from "@Pages/contactForm/types/ContactFormInputField.type";

export default function useInputHandler(checkForErrors: boolean, validate?: (any) => boolean, scrollToNextField?: () => any): ContactFormInputFieldType {
    const {elRef, executeScroll} = useScroll({})

    const {
        inputData,
        setInputData,
        handleDataInput,
        inputClassName,
        handleFocusOutOfInputField,
        goToNextInputField,
    } = useInput({
        validate,
        scrollToNextInputFunction: scrollToNextField,
    })

    const {isError, showError} = useInputError({
        inputValue: inputData,
        validate,
        checkFlag: checkForErrors,
    })

    return {
        value: inputData,
        setValue: setInputData,
        handleDataInput,
        handleFocusOutOfInputField,
        goToNextInputField,
        elRef,
        scrollToField: executeScroll,
        inputClassName,
        isError,
        showError,
    }
}